<template>
    <section class="footer-section d-flex justify-content-center gap-1" id="contact">
        <div class="footer-container ">
            <h1 class="inter-500">Contactame</h1>
            <ul class="footer-list source-code-pro-400">
                    <li class="list-item d-flex align-items-center ">
                        <img src="../assets/icons/compu.svg" class="shadow-rounded">Trabajo presencial / remoto
                    </li>
                    <li class="list-item d-flex align-items-center">
                        <img src="../assets/icons/mensaje.svg" class="shadow-rounded">rolandogomez.dev@gmail.com
                    </li>
                    <li class="list-item d-flex align-items-center">
                        <img src="../assets/icons/ubicacion.svg" class="shadow-rounded">Ciudad de México
                    </li>
                </ul>
            <p class="inter-500">Creado por <span class="source-code-pr0-300">rolandogomez.dev</span></p>
        </div>

    </section>
</template>

<script setup lang="ts">

</script>

<style scoped>
.footer-section{
    padding: 1em;
    width: 100%;
}

h1,p{
    width: 100%;
    text-align: center;
    margin-top: 1em;
}

p{
    font-size: 0.8em;
}
.footer-container{
    flex-wrap: wrap;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 4em;
    padding-top: 1em;
    font-size: 18px;
}

.footer-list{
    list-style: none;
    font-size: 0.8em;
}

.list-item{
    gap: 0.5em;
    margin: 0.5em 0;
}
span{
    background-color: var(--secondary-bg-color);
    padding: 0.3em;
    color: rgb(255, 255, 255);
    border-radius: 0.2em;
}
@media (min-width: 576px) {
    p, .footer-list{
        font-size: 1em;
    }
}
</style>